import styled from "@emotion/styled";
import { Button, DropDown, EditModal, Input, PageTable, Title } from "@src/components";
import React, { Fragment, useEffect, useRef, useState } from "react";
import userNoImg from "../../assets/userNoImg.png";
import photo from "../../assets/photo.png";
import addPhotoImg from "../../assets/addPhotoImg.png";
import Cancel from "../../assets/Cancel.png";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { userExpertDto } from "./types";
import {
    useGetChangeHistory,
    useGetChangeHistoryDetails,
    useGetUserExpert,
    usePostExperts,
    useSaveCertFileImage,
    useSaveProfileImage,
    useUpdateExperts,
    useUserNotExpertList,
} from "@src/hooks/queries/useExpert";
import { getColumns } from "./NotExpertUserListColumns";
import { ConvertPhoneNumber } from "@src/utils/units";
import { getHistoryColumns } from "./ChangeHistoryListColumns";
import { ConvertDateTime } from "@src/utils/dateUtil";
import backArrow from "../../assets/backArrow.png";
import SearchAgent from "./SearchAgent";
import SearchOffice from "./SearchOffice";
import { Common } from "@src/styles/Common";
import {
    ExpertProfileDetail,
    UpdateExpertProfileDto,
    useExpertProfileDetail,
    useUpdateExpertProfile,
} from "@src/hooks/queries/useExpertDetail";

const ExpertForm = () => {
    const expertServiceList = [
        {
            value: "경매대행",
        },
        {
            value: "매수신청대리인",
        },
        {
            value: "매물컨설팅",
        },
        {
            value: "임장동행",
        },
    ];

    const [isShowOfficeModal, setIsShowOfficeModal] = useState<boolean>(false);

    const profileRef = useRef<any>(null);
    const infoFileRef = useRef<any>(null);

    const { no } = useParams();
    const navigate = useNavigate();

    const { data: expertDetail, refetch: refetchExpertDatail } = useExpertProfileDetail(Number(no), "expertNo");
    const { mutate: updateExpertProfile } = useUpdateExpertProfile();

    const { mutate: saveProfileImage } = useSaveProfileImage();
    const { mutate: saveCertFileImage } = useSaveCertFileImage();
    const [tempExpertDetail, setTempExpertDetail] = useState<ExpertProfileDetail | null>(expertDetail ?? null);

    console.log("tempExpertDetail", tempExpertDetail);

    useEffect(() => {
        if (expertDetail && tempExpertDetail === null) {
            setTempExpertDetail(expertDetail);
        }
    }, [expertDetail]);

    const phoneNumRex = /^(010|011|016|018|019)/;

    const handleSubmit = () => {
        if (!tempExpertDetail) {
            return;
        }

        updateExpertProfile(
            {
                expertNo: tempExpertDetail?.expertNo,
                phone: tempExpertDetail?.phone,
                profile: tempExpertDetail?.profileImageUrl,
                bankName: tempExpertDetail?.bankName,
                bankAccount: tempExpertDetail?.bankAccount,
                career: tempExpertDetail?.career ?? "",
                qualification: tempExpertDetail?.qualification ?? "",
                introduction: tempExpertDetail?.intro ?? "",
                counselingCategories: tempExpertDetail?.hashTags.map((hashTag) => hashTag.replace("#", "")),
                auctionAgentCertFileUrl: tempExpertDetail?.auctionAgentRegistrationImage ?? "",
                officeInfo: {
                    name: tempExpertDetail?.office.name,
                    registrationNumber: tempExpertDetail?.office.registrationNumber,
                    ceo: tempExpertDetail?.office.ceo,
                    phone: tempExpertDetail?.office.phone,
                    address: tempExpertDetail?.office.address,
                },
                isAuctionAgent: !!tempExpertDetail?.auctionAgentRegistrationImage,
            } as UpdateExpertProfileDto,
            {
                onSuccess: () => {
                    alert("수정되었습니다.");
                },
            },
        );
    };

    return (
        <>
            <StyledExpertFormWrap>
                <Title title={no ? "전문가 회원 수정" : "전문가 회원 등록"} />
                <div className="contents">
                    <div className="userNumContents">
                        {no && (
                            <div className="changeHistory">
                                <Button
                                    color="purple"
                                    size="medium"
                                    label={no ? "수정하기" : "등록하기"}
                                    isDisabled={false}
                                    handleClick={() => {
                                        handleSubmit();
                                    }}
                                />
                                {/* <Button
                                    color="white"
                                    size="medium"
                                    label="수정이력"
                                    isDisabled={false}
                                    handleClick={() => {
                                        setIsShowChangeHistoryModal(true);
                                    }}
                                /> */}
                            </div>
                        )}
                    </div>
                    <>
                        <div className="userInfo">
                            <div className="userImgWrap">
                                <img
                                    src={tempExpertDetail?.profileImageUrl ?? userNoImg}
                                    alt=""
                                    className="userImg"
                                    onClick={() => {
                                        profileRef.current.click();
                                    }}
                                />
                                <input
                                    type="file"
                                    id="fileUpload"
                                    ref={profileRef}
                                    onChange={(e) => {
                                        if (e.target.files && expertDetail?.expertNo) {
                                            saveProfileImage(
                                                {
                                                    file: e.target.files[0],
                                                    expertNo: expertDetail?.expertNo,
                                                },
                                                {
                                                    onSuccess: (data) => {
                                                        if (tempExpertDetail) {
                                                            setTempExpertDetail({
                                                                ...tempExpertDetail,
                                                                profileImageUrl: data,
                                                            });
                                                        }
                                                    },
                                                },
                                            );
                                        }
                                    }}
                                />
                            </div>
                            <div className="userTextDiv">
                                <Input
                                    handleChange={(evt) => {}}
                                    label="이름"
                                    placeholder="미스고"
                                    size="dynamic"
                                    type="text"
                                    value={tempExpertDetail?.name ?? ""}
                                    border={true}
                                    isDisabled={true}
                                />
                                <div className="requiredInputDiv">
                                    <div className="requiredInputTitle">
                                        연락처
                                        <span className="required">*</span>
                                        <span className="addMessage">
                                            고객과 소통하는 번호로 입력 (문자/전화 문의용)
                                        </span>
                                    </div>
                                    <Input
                                        handleChange={(evt) => {
                                            if (tempExpertDetail) {
                                                setTempExpertDetail({
                                                    ...tempExpertDetail,
                                                    phone: evt.target.value,
                                                });
                                            }
                                        }}
                                        label=""
                                        placeholder="010-0000-0000"
                                        size="dynamic"
                                        type="text"
                                        value={tempExpertDetail?.phone ?? ""}
                                        border={true}
                                    />
                                    {tempExpertDetail?.phone &&
                                        !phoneNumRex.test(tempExpertDetail?.phone.slice(0, 3)) && (
                                            <span className="errorMessage">010으로 시작되는 번호로 입력해 주세요</span>
                                        )}
                                </div>

                                <Input
                                    handleChange={(evt) => {
                                        if (tempExpertDetail) {
                                            setTempExpertDetail({
                                                ...tempExpertDetail,
                                                bankName: evt.target.value,
                                            });
                                        }
                                    }}
                                    label="은행"
                                    placeholder="미스고"
                                    size="small"
                                    type="text"
                                    value={tempExpertDetail?.bankName ?? "-"}
                                    border={true}
                                    isDisabled={false}
                                />
                                <Input
                                    handleChange={(evt) => {
                                        if (tempExpertDetail) {
                                            setTempExpertDetail({
                                                ...tempExpertDetail,
                                                bankAccount: evt.target.value,
                                            });
                                        }
                                    }}
                                    label="계좌번호"
                                    placeholder="미스고"
                                    size="dynamic"
                                    type="text"
                                    value={tempExpertDetail?.bankAccount ?? "-"}
                                    border={true}
                                    isDisabled={false}
                                />
                            </div>
                        </div>
                        <div className="officeInfo">
                            <div className="searchInfoWrap">
                                <div style={{ display: "flex" }}>
                                    <Title title="중개사무소(중개법인) 정보" />
                                    <span className="required">*</span>
                                    <Button
                                        color="white"
                                        size="small"
                                        label="조회하기 "
                                        isDisabled={false}
                                        styles={{ marginLeft: 10 }}
                                        handleClick={() => {
                                            setIsShowOfficeModal(true);
                                        }}
                                    />
                                </div>

                                {tempExpertDetail?.office.name && (
                                    <div className="officeBox">
                                        <div className="officeRow">
                                            <span className="name">사무소명</span>
                                            <span className="text">{tempExpertDetail?.office.name}</span>
                                        </div>

                                        <div className="officeRow">
                                            <span className="name">중개등록번호</span>
                                            <span className="text">{tempExpertDetail?.office.registrationNumber}</span>
                                        </div>

                                        <div className="officeRow">
                                            <span className="name">대표</span>
                                            <span className="text">{tempExpertDetail?.office.ceo}</span>
                                        </div>
                                        <div className="officeRow">
                                            <span className="name">전화번호</span>
                                            <span className="text">{tempExpertDetail?.office.phone}</span>
                                        </div>
                                        <div className="officeRow">
                                            <span className="name">소재지</span>
                                            <span className="text">{tempExpertDetail?.office.address}</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="counselingField">
                                <div className="titleWrap">
                                    <Title title="수행기능 (중복 선택 가능)" />
                                </div>
                                <div className="buttonDiv">
                                    {expertServiceList.map((item) => {
                                        return (
                                            <Button
                                                key={item.value}
                                                color={
                                                    tempExpertDetail?.hashTags?.some((category) =>
                                                        category.includes(item.value),
                                                    )
                                                        ? "purple"
                                                        : "gray"
                                                }
                                                size="small"
                                                label={item.value}
                                                isDisabled={false}
                                                handleClick={() => {
                                                    if (tempExpertDetail) {
                                                        setTempExpertDetail({
                                                            ...tempExpertDetail,
                                                            hashTags: tempExpertDetail.hashTags.some((category) =>
                                                                category.includes(item.value),
                                                            )
                                                                ? tempExpertDetail.hashTags.filter(
                                                                      (text) => !text.includes(item.value),
                                                                  )
                                                                : [...tempExpertDetail.hashTags, `#${item.value}`],
                                                        });
                                                    }
                                                }}
                                            />
                                        );
                                    })}
                                </div>

                                <div className="officePhotoWrap">
                                    <Title title="매수신청대리인 등록증" />
                                    <input
                                        type="file"
                                        id="infoFileUpload"
                                        style={{ display: "none" }}
                                        ref={infoFileRef}
                                        onChange={(e) => {
                                            if (e.target.files && expertDetail?.expertNo) {
                                                saveCertFileImage(
                                                    {
                                                        file: e.target.files[0],
                                                        expertNo: expertDetail?.expertNo,
                                                    },
                                                    {
                                                        onSuccess: (data) => {
                                                            if (tempExpertDetail) {
                                                                setTempExpertDetail({
                                                                    ...tempExpertDetail,
                                                                    auctionAgentRegistrationImage: data,
                                                                });
                                                            }
                                                        },
                                                    },
                                                );
                                            }
                                        }}
                                    />
                                    <div className="imgList">
                                        <img
                                            src={addPhotoImg}
                                            alt=""
                                            onClick={() => {
                                                infoFileRef.current.click();
                                            }}
                                        />
                                        <div className="fileCount">
                                            {tempExpertDetail?.auctionAgentRegistrationImage ? "(1/1)" : "(0/1)"}
                                        </div>
                                        {tempExpertDetail?.auctionAgentRegistrationImage && (
                                            <img src={tempExpertDetail?.auctionAgentRegistrationImage} alt="" />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="textBox">
                            <div className="textItem">
                                <Title title="경력" />
                                <textarea
                                    placeholder="경력을 입력해주시면 회원분들의 선택에 도움이 됩니다(최대200자)"
                                    onChange={(e) => {
                                        if (tempExpertDetail) {
                                            setTempExpertDetail({
                                                ...tempExpertDetail,
                                                career: e.target.value,
                                            });
                                        }
                                    }}
                                    value={tempExpertDetail?.career ?? ""}
                                />
                            </div>
                            <div className="textItem">
                                <Title title="자격" />
                                <textarea
                                    placeholder="공인중개사 외의 다른 자격 사항이 있으시면 기재해 주세요(최대200자)"
                                    onChange={(e) => {
                                        if (tempExpertDetail) {
                                            setTempExpertDetail({
                                                ...tempExpertDetail,
                                                qualification: e.target.value,
                                            });
                                        }
                                    }}
                                    value={tempExpertDetail?.qualification ?? ""}
                                />
                            </div>
                            <div className="textItem">
                                <Title title="소개" />
                                <textarea
                                    className="introduce"
                                    placeholder="전문가님을 기다리는 회원분들께 소개의 글을 작성해 주세요(최대500자)"
                                    onChange={(e) => {
                                        if (tempExpertDetail) {
                                            setTempExpertDetail({
                                                ...tempExpertDetail,
                                                intro: e.target.value,
                                            });
                                        }
                                    }}
                                    value={tempExpertDetail?.intro ?? ""}
                                />
                            </div>
                        </div>
                    </>
                </div>
            </StyledExpertFormWrap>
            {/* <EditModal
                buttonText="저장"
                handleBtnClick={() => {}}
                handleOpenModal={() => {
                    setIsShowUserInfoModal(false);
                }}
                size="fitContent"
                title="회원정보 가져오기"
                isModalShow={isShowUserInfoModal}
                dimClose={true}
                checkCloseModal={true}
            >
                <StyledUserInfoWrap>
                    <div className="searchDiv">
                        <DropDown
                            data={userDropDown}
                            defaultValue=""
                            handleChange={(e, text, value) => {
                                if (value) {
                                    setNotExpertListParams({
                                        ...notExpertListParams,
                                        searchType: value,
                                    });
                                }
                            }}
                            label=""
                        />
                        <Input
                            handleChange={(evt) => {
                                setNotExpertListParams({
                                    ...notExpertListParams,
                                    searchValue: evt.target.value,
                                });
                            }}
                            label=""
                            placeholder="성명, 이메일주소, 핸드폰번호를 입력하세요"
                            size="big"
                            type="text"
                            value={notExpertListParams.searchValue}
                            border={true}
                        />
                        <Button
                            color="purple"
                            size="small"
                            label="검색"
                            isDisabled={false}
                            handleClick={() => {
                                refetch();
                            }}
                            styles={{
                                width: 153,
                                height: 48,
                            }}
                        />
                    </div>
                    <PageTable
                        columns={columns}
                        data={data?.result ?? []}
                        initialState={{
                            pageIndex: 0,
                            pageSize: 10,
                        }}
                        FixedHeight={500}
                        showTotalCount={true}
                        totalCount={data?.total ?? 0}
                        handlePageChange={(index: number) => {
                            const page = index + 1;
                            setNotExpertListParams({
                                ...notExpertListParams,
                                page,
                            });
                        }}
                    ></PageTable>
                </StyledUserInfoWrap>
            </EditModal> */}

            <EditModal
                buttonText=""
                handleBtnClick={() => {}}
                handleOpenModal={() => setIsShowOfficeModal(false)}
                size="big"
                title="중개사무소 조회"
                isModalShow={isShowOfficeModal}
                dimClose={true}
                checkCloseModal={true}
                deleteButton={true}
            >
                <>
                    <SearchAgent setExpertData={setTempExpertDetail} setIsShowOfficeModal={setIsShowOfficeModal} />

                    {/* <SearchOffice
                            expertData={expertData}
                            setExpertData={setExpertData}
                            setIsShowOfficeModal={setIsShowOfficeModal}
                        /> */}
                </>
            </EditModal>
        </>
    );
};

export default ExpertForm;

const StyledExpertFormWrap = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 40px;
    gap: 20px;
    box-sizing: border-box;
    .contents {
        display: flex;
        flex-direction: column;
        .userNumContents {
            display: flex;
            gap: 20px;
            .userNo {
                display: flex;
                align-items: center;
            }
            .changeHistory {
                display: flex;
                gap: 10px;
                align-items: center;
                flex-direction: column;
                position: absolute;
                top: 80px;
                right: 40px;
            }
        }
        .userInfo {
            display: flex;
            gap: 40px;
            margin-top: 57px;
            .userImgWrap {
                display: flex;
                flex-direction: column;
                gap: 32px;
                align-items: center;
                position: relative;
                .userImg {
                    width: 110px;
                    height: 110px;
                    border-radius: 55px;
                }
                .photo {
                    width: 40px;
                    height: 40px;
                    position: absolute;
                    left: 181px;
                    bottom: 74px;
                }
                .buttonDiv {
                    display: flex;
                    gap: 10px;
                    flex-wrap: nowrap;
                }
            }
            .userTextDiv {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                gap: 8px;
                & > input {
                    width: 360px;
                    height: 42px;
                    background-color: #fff;
                }
                .requiredInputDiv {
                    display: flex;
                    flex-direction: column;
                    gap: 9px;
                    & > input {
                        width: 360px;
                        height: 42px;
                    }
                    .requiredInputTitle {
                        display: flex;
                        font-size: 14px;
                        font-weight: 500;
                        line-height: 140%;
                        .required {
                            line-height: 22px;
                            font-size: 30px;
                            font-weight: 700;
                            display: flex;
                            align-items: flex-start;
                            color: #ff0000;
                        }
                        .addMessage {
                            font-size: 10px;
                            font-weight: 400;
                            line-height: 12px;
                            color: #ff0000;
                            padding-left: 13px;
                            display: flex;
                            align-items: center;
                        }
                    }
                    .errorMessage {
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 12px;
                        color: #ff0000;
                    }
                }
            }
        }
        .officeInfo {
            display: flex;
            gap: 108px;
            margin-top: 70px;
            .searchInfoWrap {
                display: flex;
                flex-direction: column;
                gap: 16px;
                .required {
                    line-height: 22px;
                    font-size: 30px;
                    font-weight: 700;
                    display: flex;
                    align-items: flex-start;
                    color: #ff0000;
                    padding-left: 5px;
                }
                .officeBox {
                    width: 400px;
                    padding: 20px 0;
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    justify-content: center;
                    flex-direction: column;

                    .officeRow {
                        display: flex;
                        width: 100%;
                        gap: 30px;
                        padding-bottom: 10px;
                        border-bottom: 1px solid ${Common.colors.gray200};
                        line-height: 1.2;
                        .name {
                            color: ${Common.colors.gray500};
                            width: 100px;
                            min-width: 100px;
                            font-size: 14px;
                        }
                    }
                }
            }
            .officePhotoWrap {
                display: flex;
                flex-direction: column;
                gap: 10px;
                margin-top: 40px;
                & > p {
                    font-size: 10px;
                    font-weight: 400;
                    line-height: 12px;
                }
                .imgList {
                    display: flex;
                    gap: 10px;
                    position: relative;
                    .fileCount {
                        position: absolute;
                        bottom: 10px;
                        left: 24px;
                    }
                    & > img {
                        width: 85px;
                        height: 85px;

                        object-fit: cover;
                    }
                }
            }
        }
        .counselingField {
            display: flex;
            flex-direction: column;
            gap: 20px;

            .titleWrap {
                display: flex;
                flex-direction: column;
                gap: 6px;
                & > p {
                    font-size: 10px;
                    font-weight: 400;
                    line-height: 12px;
                }
            }
            .buttonDiv {
                display: flex;

                gap: 14px;
                .buttonRow {
                    display: flex;
                    gap: 14px;
                    align-items: center;
                }
            }
        }
        .consultationFee {
            display: flex;
            flex-direction: column;
            gap: 24px;
            margin-top: 80px;
            .required {
                line-height: 22px;
                font-size: 30px;
                font-weight: 700;
                display: flex;
                align-items: flex-start;
                color: #ff0000;
                padding-left: 5px;
            }
            .contentsWrap {
                display: flex;
                gap: 20px;
                .inputWrap {
                    display: flex;
                    flex-direction: column;
                    width: fit-content;
                    position: relative;
                    gap: 8px;
                    .inputRow {
                        display: flex;
                        gap: 18px;
                        .name {
                            font-size: 18px;
                            font-weight: 400;
                            line-height: 22px;
                            width: 80px;
                            color: #8d8d8d;
                            :first-of-type {
                                padding-top: 19px;
                            }
                        }
                        .inputContents {
                            display: flex;
                            flex-direction: column;
                            gap: 8px;
                        }
                        & > .inputContents {
                            & > div {
                                & > label {
                                    & > select {
                                        color: #222222;
                                        font-weight: 400;
                                        font-size: 14px;
                                        border: 1px solid #b4b4b9;
                                        border-radius: 10px;
                                        width: 328px;
                                        height: 56px;
                                    }
                                }
                            }
                        }
                        .textInput {
                            width: 328px;
                            height: 56px;
                            background-color: #f0f0f0;
                            border-radius: 10px;
                            border: none;
                        }
                    }
                }
                .tableArea {
                    & > table {
                        width: 500px;
                        border: 2px solid #f0f0f0;
                        border-collapse: collapse;
                        & > thead {
                            width: 500px;
                            height: 60px;
                            & > tr {
                                width: 100%;
                                height: 100%;
                                background-color: #d9d9d9;
                                & > th {
                                    text-align: center;
                                    vertical-align: middle;
                                    :nth-of-type(1) {
                                        width: 200px !important;
                                    }
                                    :nth-of-type(2) {
                                        width: 250px !important;
                                    }
                                }
                            }
                        }
                        & > tbody {
                            height: fit-content;
                            & > tr {
                                width: 500px;
                                height: 60px;
                                & > td {
                                    text-align: center;
                                    vertical-align: middle;
                                    padding: 14px;
                                    & > img {
                                        width: 26px;
                                        height: 26px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .textBox {
            display: flex;
            flex-direction: column;
            gap: 40px;
            margin-top: 100px;
            .textItem {
                display: flex;
                flex-direction: column;
                & > textarea {
                    width: 908px;
                    height: 116px;
                    background-color: #f0f0f0;
                    border-radius: 10px;
                    border: none;
                    padding: 14px 18px;
                    resize: none;
                }
                .introduce {
                    height: 245px;
                }
            }
        }
    }
`;

const StyledUserInfoWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
    .searchDiv {
        display: flex;
        gap: 14px;
    }
    & > .searchDiv {
        & > div {
            & > label {
                & > select {
                    color: #222222;
                    font-weight: 400;
                    font-size: 14px;
                    border: 1px solid #b4b4b9;
                    border-radius: 10px;
                    height: 48px;
                }
            }
        }
    }
`;

const StyledHistoryDetailContents = styled.div`
    display: flex;
    flex-direction: column;
    gap: 25px;
    .backButton {
        width: 30px;
        & > img {
            width: 100%;
        }
        margin-bottom: 10px;
    }
    .itemRow {
        display: flex;
        gap: 20px;
        align-items: center;
        .name {
            color: #959595;
            white-space: nowrap;
            width: 80px;
        }
    }
    .contentsBox {
        display: flex;
        gap: 20px;
        .name {
            color: #959595;
            white-space: nowrap;
            width: 80px;
        }
        .contentsList {
            display: flex;
            flex-direction: column;
            gap: 25px;
            .contentsItem {
                display: flex;
                flex-direction: column;
                gap: 15px;
                .title {
                    font-size: 18px;
                    font-weight: 700;
                }
                .contentsLine {
                    display: flex;
                    gap: 20px;
                    align-items: center;
                    .prevBox {
                        min-width: 300px;
                        width: 50%;
                        min-height: 100px;
                        height: fit-content;
                        padding: 20px;
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                        background-color: #ededed;
                    }
                    .arrow {
                        font-size: 30px;
                        font-weight: 400;
                        color: #000000;
                        white-space: nowrap;
                    }
                    .currentBox {
                        min-width: 300px;
                        width: 50%;
                        min-height: 100px;
                        height: fit-content;
                        padding: 20px;
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                        background-color: #ededed;
                        & > img {
                            width: 110px;
                            height: 110px;
                            border-radius: 55px;
                        }
                    }
                    .tableArea {
                        & > table {
                            width: 500px;
                            border: 2px solid #f0f0f0;
                            border-collapse: collapse;
                            & > thead {
                                width: 500px;
                                height: 60px;
                                & > tr {
                                    width: 100%;
                                    height: 100%;
                                    background-color: #d9d9d9;
                                    & > th {
                                        text-align: center;
                                        vertical-align: middle;
                                        :nth-of-type(1) {
                                            width: 200px !important;
                                        }
                                        :nth-of-type(2) {
                                            width: 250px !important;
                                        }
                                    }
                                }
                            }
                            & > tbody {
                                height: fit-content;
                                & > tr {
                                    width: 500px;
                                    height: 60px;
                                    & > td {
                                        text-align: center;
                                        vertical-align: middle;
                                        padding: 14px;
                                        & > img {
                                            width: 26px;
                                            height: 26px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .officeTab {
                        display: flex;
                        flex-direction: column;
                        min-width: 183px;
                        width: 50%;
                        min-height: 100px;
                        height: fit-content;
                        padding: 30px 40px;
                        border-top: 1px solid black;
                        border-bottom: 1px solid black;
                        gap: 20px;
                        .officeLine {
                            display: flex;
                            gap: 30px;
                            align-items: center;
                            .officeName {
                                width: 100px;
                            }
                        }
                    }
                }
            }
        }
    }
`;
